import React from "react";
import { MainContentMobileWrapper, MainContentWrapper } from "./Styled";
import { Paper, Toolbar } from "@mui/material";
import { useGlobalContext } from "context/GlobalContext";

export const MainContent = ({ children }) => {
  const { isMobile } = useGlobalContext();
  return !isMobile ? (
    <MainContentWrapper>
      <Toolbar variant="dense" />
      <Paper>{children}</Paper>
    </MainContentWrapper>
  ) : (
    <MainContentMobileWrapper>{children}</MainContentMobileWrapper>
  );
};
